export default __webpack_public_path__ + "static/media/config-grey.659900c1.svg";